import { securedAxios } from "../lib/axios";
import _ from "lodash";
import urljson from "../lib/urljson";
const enderecoModelo = {
  nome: "",
  descricao: "",
  principal: false,
  endereco: "",
  numero: "",
  complemento: "",
  bairro: "",
  id_cidade: null,
  cep: "",
  cidade: null,
  tipos: [],
};
export default {
  namespaced: true,
  state: {
    enderecoAtivo: null,
    tiposEndereco: [
      {
        text: "Matriz",
        value: "matriz",
      },
      {
        text: "Filial",
        value: "filial",
      },
      {
        text: "Cobrança",
        value: "cobranca",
      },
      {
        text: "Entrega / Obra",
        value: "entrega",
      },
      {
        text: "Armazém",
        value: "armazem",
      },
      {
        text: "Receita",
        value: "receita",
      },
      {
        text: "Outro",
        value: "outro",
      },
    ],
  },
  getters: {
    strTipoEndereco: (state) => (tipo) =>
      state.tiposEndereco.find((t) => t.value === tipo).text,
  },
  mutations: {
    novoEndereco(state) {
      state.enderecoAtivo = _.clone(enderecoModelo);
    },
    editarEndereco(state, endereco) {
      state.enderecoAtivo = _.clone(endereco);
    },
    limparEnderecoAtivo(state) {
      state.enderecoAtivo = null;
    },
  },
  actions: {
    async listarEnderecos(context, { tipo, id_entidade }) {
      const response = await securedAxios.get(
        `/${tipo}/${id_entidade}/enderecos`
      );
      return Promise.resolve(response.data);
    },
    async gravarEnderecos(context, { tipo, id_entidade, enderecos }) {
      const promises = enderecos.map((endereco) => {
        return new Promise((resolve, reject) => {
          let p;
          if (endereco.editar) {
            p = securedAxios.put(
              `/${tipo}/${id_entidade}/enderecos/${endereco.id}`,
              endereco
            );
          } else if (endereco.remover) {
            p = securedAxios.delete(
              `/${tipo}/${id_entidade}/enderecos/${endereco.id}`
            );
          } else if (endereco.novo) {
            p = securedAxios.post(
              `/${tipo}/${id_entidade}/enderecos`,
              endereco
            );
          } else {
            return resolve(endereco);
          }

          p.then(
            (response) => resolve(response.data),
            (err) => reject(err)
          );
        });
      });
      return Promise.all(promises);
    },
    async checar(context, { tipo, chave }) {
      if (chave === "") {
        return Promise.resolve(false);
      }
      try {
        const response = await securedAxios.get(
          `/${tipo}?opcoes=${urljson({ filtros: { cpf_cnpj: chave } })}`
        );
        return Promise.resolve(response.data.length === 0);
      } catch (e) {
        console.log(e);
        return Promise.resolve(true);
      }
    },
  },
};
